export default "__VITE_ASSET__CIhRww7q__"